import React, { type FC } from 'react';
import classnames from 'classnames';
import styles from './Poll.module.css';
import { type IPollChoice, type IPollQuestion } from './records';

interface Props {
  question: IPollQuestion;
  selectedChoiceId?: string;
  onSelectChoice: (choice: IPollChoice) => void;
}

const CustomerSatisfaction: FC<Props> = ({
  question,
  selectedChoiceId,
  onSelectChoice,
}) => {
  return (
    <>
      <div className={styles.customerSatisfaction}>
        {question.choices
          .map((choice: IPollChoice, index: number) => (
            <div
              key={choice.id || index}
              onClick={() => onSelectChoice(choice)}
              onTouchStart={() => onSelectChoice(choice)}
              className={classnames(styles.number, {
                [styles.numberSelected]: selectedChoiceId === choice.id,
              })}
            >
              {index}
            </div>
          ))
          .toArray()}
      </div>
      <div className={`${styles.labels} ${styles.customerSatisfactionLabels}`}>
        <span className={styles.lowLabel}>{question.low_label}</span>
        <span className={styles.highLabel}>{question.high_label}</span>
      </div>
    </>
  );
};

export default CustomerSatisfaction;
